<template>
  <div class="data-list-container">
    <ajoutModification :base="base"></ajoutModification>
    <OTDdataTableGeneral :base="base"></OTDdataTableGeneral>
  </div>
</template>

<script>
var headers = require("./headers.js")
var base_self
import ajoutModification from './ajoutModification.vue'

export default {
  components: {
    ajoutModification
  },
  data() {
    return {
      dataTableComponent: '',
      ajoutComponent: '',
      item: '',
      visibilite: {
        Create: false,
        Update: false,
        delete: false,
        Excel: false,
        checkBoxAll: false,
        supprimerLot: false
      },
      datas_second: [],
      addOrUpdateItem: false,
      sidebarData: {},
      url: '/forum/subjects'
    }
  },
  computed: {
    datas () {
      let array = []
      let length = base_self.datas_second.length

      for (var i = 0; i < length; i++) {
        let element = base_self.datas_second[i]
        // element.author = element.user ? (element.user.lastname + ' ' + element.user.firstname) : ''
        /* if (window.getApp.category) {
          if (window.getApp.category === element.category_training.slug) {
            array.push(element)
          }
        } else {
          array.push(element)
        } */
        
        array.push(element)
      }

      return array
    },
    base () {
      return base_self
    },
    headers () {
      return headers
    }
  },
  methods: {
    getList () {
      base_self.$vs.loading()
      base_self.$http.get(base_self.url)
      .then((response) => { base_self.$vs.loading.close(); base_self.datas_second = response.data.data; console.log('base_self.datas_second: ', base_self.datas_second) })
      .catch((error) => { window.getApp.error(error) })
    },
    supprimerAll: async (array) => {
      base_self.$vs.loading()
      var length = array.length
      for (var i = 0; i < length; i++) {
        await base_self.$http.delete(base_self.url + `/${array[i].slug}`)
        .catch((error) => { window.getApp.error(error) })
      }

      base_self.$vs.loading.close();
      base_self.getList()
      base_self.dataTableComponent.selected78888888 = []
    },
    supprimer (itemSupprimer) {
      base_self.$vs.loading()
      base_self.$http.delete(base_self.url + `/${itemSupprimer.slug}`)
      .then((response) => { window.getApp.success(window.getApp.suppresionMessage, response); base_self.getList() })
      .catch((error) => { window.getApp.error(error) })
    }
  },
  created() {
    base_self = this
  },
  mounted() {
    base_self.getList()
  }
}
</script>
